<template>
  <div class="adjustment-popup edit-adjustment-modal">
    <CustomModal
      @close="$emit('close')"
      @ok="submitAdjustment"
      :title="'Edit Adjustment'"
      :okButtonText="'Update Adjustment'"
      :width="modalWidth"
    >
      <div slot="body">
        <div class="create-adjustment-schedule-error" v-if="showErrorMessage">
          <img src="../../assets/error_red.png" />
          <span>{{ errorMessage }}</span>
        </div>
        <div class="create-holiday-basic-info-container">
          <div class="form-field">
            <label class="form-label">Name</label>
            <input
              v-model="name"
              placeholder="Holiday Name"
              class="holiday-name"
            />
          </div>

          <div class="form-field">
            <input-date-range v-model="rangeDate" />
          </div>

          <div class="form-field">
            <div class="form-label">Type</div>
            <div class="types-wrapper">
              <div
                v-for="type of types"
                class="holiday-type"
                :class="{
                  'holiday-type-selected': selectedType == type
                }"
                :key="type"
                @click="selType(type)"
              >
                {{ type }}
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-field form-field-half">
              <label class="form-label">Select</label>
              <div class="row-quantity">
                <div
                  v-for="type of quantityType"
                  class="quantity-type"
                  :class="{
                    'holiday-type-selected': selectedQuantity == type
                  }"
                  :key="type"
                  @click="selectedQuantityType(type)"
                >
                  {{ type }}
                </div>
              </div>
            </div>
            <div class="form-field form-field-half">
              <label class="form-label">Quantity</label>
              <input
                v-model="quantity"
                placeholder="Quantity"
                class="holiday-quantity"
              />
            </div>
          </div>
        </div>
      </div>
    </CustomModal>
  </div>
</template>
<script>
import CustomModal from '@/components/shared/modal/CustomModal.vue'
import InputDateRange from '@/components/InputDateRange.vue'

export default {
  components: {
    CustomModal,
    InputDateRange
  },
  data() {
    return {
      uuid: '',
      name: '',
      selectedType: null,
      selectedQuantity: null,
      date: '',
      quantity: '',
      quantityType: ['Percentage', 'Amount'],
      types: ['Decrease', 'Increase'],
      rangeDate: null,
      showErrorMessage: false,
      errorMessage: '',
      isMobileView: false
    }
  },
  computed: {
    modalWidth() {
      return this.isMobileView ? '100%' : '560px'
    }
  },
  mounted() {
    document.body.appendChild(this.$el)
    this._checkMobileView = () => {
      this.isMobileView = window.innerWidth <= 768
    }
    this._checkMobileView()
    window.addEventListener('resize', this._checkMobileView)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this._checkMobileView)
    if (this.$el && this.$el.parentNode === document.body) {
      document.body.removeChild(this.$el)
    }
  },
  methods: {
    setData() {
      this.uuid = this.data.uuid
      this.name = this.data.name
      this.selectedType = this.data.type
      this.selectedQuantity = this.data.select

      this.rangeDate = [
        new Date(this.data.start_date),
        new Date(this.data.end_date)
      ]
      if (this.data.select === 'Percentage')
        this.quantity = this.data.quantity + '%'
      else this.quantity = '$' + this.data.quantity
    },
    selType(type) {
      this.selectedType = type
    },
    selectedQuantityType(type) {
      this.selectedQuantity = type
      if (type == 'Percentage') this.quantity = '%'
      else this.quantity = '$'
    },
    validSchedule() {
      const startDate = new Date(this.rangeDate[0])
      const endDate = new Date(this.rangeDate[1])

      for (let i = 0; i < this.adjustments.length; i++) {
        const holiday = this.adjustments[i]
        if (holiday.uuid !== this.uuid) {
          let tempStart = new Date(holiday.startDate)
          let tempEnd = new Date(holiday.endDate)

          if (startDate >= tempStart && startDate <= tempEnd) return false

          if (endDate >= tempStart && endDate <= tempEnd) return false
        }
      }

      return true
    },
    submitAdjustment() {
      if (!this.validSchedule()) {
        this.showErrorMessage = true
        this.errorMessage = 'An existing adjustment overlaps with this dates'
        return
      } else {
        this.showErrorMessage = false
      }

      const holiday = {
        uuid: this.uuid,
        name: this.name,
        quantity: this.quantity.replace('$', '').replace('%', ''),
        type: this.selectedType,
        selectedType: this.selectedQuantity,
        rangeDate: this.rangeDate
      }
      this.$emit('ok', holiday)
    }
  },
  props: {
    adjustments: {
      type: Array
    },
    data: {
      type: Object
    }
  },
  created() {
    this.setData()
  }
}
</script>

<style scoped>
.create-holiday-basic-info-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0;
  padding: 0;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}

.form-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
}

.form-row {
  display: flex;
  align-items: flex-end;
  gap: 16px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.form-field-half {
  flex: 1;
  min-width: 0;
}

.form-label,
label {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 18px;
  color: #4a4a4a;
}

.holiday-type,
.quantity-type {
  flex: 1;
  min-width: 0;
  padding: 10px 8px;
  height: 18px;
  border: solid 1px;
  border-radius: 4px;
  border-color: #dfdfdf;
  color: #767675;
  cursor: pointer;
  font-size: 13px;
  font-family: Montserrat;
  text-align: center;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}

.holiday-type-selected {
  border: solid 1px;
  border-color: var(--rentalios-dark);
  background-color: #ebf0e6;
  color: var(--rentalios-dark);
}

.row-quantity,
.types-wrapper {
  display: flex;
  align-items: stretch;
  gap: 8px;
  width: 100%;
}

.edit-adjustment-modal .modal-mask {
  z-index: 1;
}

.holiday-quantity,
.holiday-name {
  width: 100%;
  height: 40px;
  border: 1px solid #cbd4dc;
  box-sizing: border-box;
  border-radius: 5px;
  padding: 0 12px;
  font-family: Montserrat;
  font-size: 13px;
  color: #4a4a4a;
}

.holiday-quantity::placeholder,
.holiday-name::placeholder {
  color: #767675;
}

.create-adjustment-schedule-error {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  padding: 12px;
  width: 100%;
  box-sizing: border-box;
  color: red;
  background: rgba(223, 0, 15, 0.05);
  border-radius: 6px;
  margin-bottom: 14px;
}

.create-adjustment-schedule-error span {
  margin-left: 12px;
  color: #df000f;
  font-family: Montserrat;
  font-weight: 900;
  font-size: 13px;
  line-height: 18px;
}

@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .form-field-half {
    flex: none;
    min-width: 0;
    width: 100%;
    max-width: 100%;
  }

  .create-adjustment-schedule-error {
    align-items: flex-start;
  }

  .create-adjustment-schedule-error span {
    flex: 1;
    min-width: 0;
  }
}

@media (max-width: 480px) {
  .create-holiday-basic-info-container {
    gap: 14px;
  }

  .holiday-type,
  .quantity-type {
    font-size: 12px;
    padding: 10px 4px;
  }
}
</style>

<style>
.adjustment-popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9998;
  pointer-events: none;
}

.adjustment-popup .modal-wrapper {
  pointer-events: auto;
}

@media (max-width: 768px) {
  .adjustment-popup .modal-wrapper {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    width: 100% !important;
    max-width: 100vw !important;
    height: 100% !important;
    margin: 0 !important;
    padding: 16px !important;
    box-sizing: border-box !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    transform: none !important;
    z-index: 9999 !important;
  }

  .adjustment-popup .modal-container {
    width: 100% !important;
    max-width: 100% !important;
    max-height: calc(100vh - 32px) !important;
    overflow-x: hidden !important;
    overflow-y: auto !important;
    padding: 16px 20px !important;
    box-sizing: border-box !important;
    border-radius: 8px;
    margin: 0 !important;
    -webkit-overflow-scrolling: touch;
  }

  .adjustment-popup .modal-body {
    margin: 16px 0 !important;
    overflow-x: hidden !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
  }

  .adjustment-popup .modal-footer {
    display: flex !important;
    flex-direction: column-reverse !important;
    gap: 10px !important;
    text-align: stretch !important;
  }

  .adjustment-popup .modal-cancel-button,
  .adjustment-popup .modal-ok-button {
    width: 100% !important;
    max-width: 100% !important;
    margin-right: 0 !important;
    line-height: 44px !important;
    box-sizing: border-box !important;
  }
}

@media (max-width: 480px) {
  .adjustment-popup .modal-wrapper {
    padding: 12px !important;
  }

  .adjustment-popup .modal-container {
    max-height: calc(100vh - 24px) !important;
    padding: 14px 16px !important;
  }
}
</style>
